import { useContext } from 'react';

import { WindowContext } from '../contexts/WindowContext';

export const useWindowContext = () => useContext(WindowContext);
